'use strict'

exports.flow = {36: require('./tokenize-math-flow')}
exports.text = {36: require('./tokenize-math-text')}
